import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "submitBtn", "submitText", "sendIcon", "spinner", "ccWrapper", "ccToggle", "fileInput", "fileList", "editor", "bodyField"]

  static values = { modalId: String }

  connect() {
    if (this.hasEditorTarget) {
      this.editorTarget.addEventListener("input", () => this.syncBody())
    }
    this.element.addEventListener("turbo:submit-end", (event) => {
      if (!event.detail.success) this.resetForm()
    })
  }

  prefill(event) {
    const { subject, body } = event.detail || {}
    const subjectInput = this.element.querySelector("input[name='subject']")
    if (subjectInput && subject) subjectInput.value = subject
    if (this.hasEditorTarget && body) {
      this.editorTarget.innerHTML = body
      this.syncBody()
    }
    this.element.classList.remove("hidden")
  }

  toggleCc() {
    if (!this.hasCcWrapperTarget) return
    const visible = !this.ccWrapperTarget.classList.contains("hidden")
    this.ccWrapperTarget.classList.toggle("hidden")
    if (this.hasCcToggleTarget) {
      this.ccToggleTarget.textContent = visible ? "+ CC" : "- CC"
    }
  }

  submit() {
    this.syncBody()
    this.submitBtnTarget.disabled = true
    if (this.hasSubmitTextTarget) this.submitTextTarget.textContent = "Envoi..."
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("hidden")
    if (this.hasSendIconTarget) this.sendIconTarget.classList.add("hidden")
  }

  resetForm() {
    this.submitBtnTarget.disabled = false
    if (this.hasSubmitTextTarget) this.submitTextTarget.textContent = "Envoyer"
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden")
    if (this.hasSendIconTarget) this.sendIconTarget.classList.remove("hidden")
  }

  syncBody() {
    if (this.hasEditorTarget && this.hasBodyFieldTarget) {
      this.bodyFieldTarget.value = this.editorTarget.innerHTML
    }
  }

  bold() { document.execCommand("bold") }
  italic() { document.execCommand("italic") }
  underline() { document.execCommand("underline") }
  bulletList() { document.execCommand("insertUnorderedList") }

  insertLink() {
    const url = prompt("URL du lien :")
    if (url) document.execCommand("createLink", false, url)
  }

  addFiles() {
    if (this.hasFileInputTarget) this.fileInputTarget.click()
  }

  filesChanged() {
    this.renderFileList()
  }

  removeFile(event) {
    const index = parseInt(event.params.index)
    const dt = new DataTransfer()
    const files = this.fileInputTarget.files
    for (let i = 0; i < files.length; i++) {
      if (i !== index) dt.items.add(files[i])
    }
    this.fileInputTarget.files = dt.files
    this.renderFileList()
  }

  renderFileList() {
    if (!this.hasFileListTarget || !this.hasFileInputTarget) return
    const files = this.fileInputTarget.files
    if (!files.length) {
      this.fileListTarget.classList.add("hidden")
      this.fileListTarget.innerHTML = ""
      return
    }

    this.fileListTarget.classList.remove("hidden")
    let html = ""
    for (let i = 0; i < files.length; i++) {
      const sizeKb = files[i].size / 1024
      const size = sizeKb > 1024 ? (sizeKb / 1024).toFixed(1) + " Mo" : Math.round(sizeKb) + " Ko"
      html += `<div class="flex items-center justify-between gap-2 px-2.5 py-1.5 bg-surface-2 rounded-lg">
        <div class="flex items-center gap-2 min-w-0">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-text-muted flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
          </svg>
          <span class="text-xs text-text-primary truncate">${files[i].name}</span>
          <span class="text-[10px] text-text-muted flex-shrink-0">${size}</span>
        </div>
        <button type="button" data-action="email-compose#removeFile" data-email-compose-index-param="${i}" class="p-0.5 rounded hover:bg-danger/10 text-text-muted hover:text-danger transition-colors cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>`
    }
    this.fileListTarget.innerHTML = html
  }
}
